(function() {
	'use strict';
	angular.module('app.dashboard')
		.service('dashboardFilterInitializationService', dashboardFilterInitializationService);

	dashboardFilterInitializationService.$inject = ['$rootScope', '$timeout', '$http', 'URLS', 'leanFilterService', 'performanceDashboardDescription',
		'leanTableConfigService', 'addUserDashboardUrl', 'tableFilterFunctionsService', 'storeService'];
	function dashboardFilterInitializationService($rootScope, $timeout, $http, URLS, leanFilterService, performanceDashboardDescription,
												  leanTableConfigService, addUserDashboardUrl, tableFilterFunctionsService, storeService) {
		var self = this;
		self.updating = {'initialLoad': true};
		var widgetList = [];
		var widgetCreatingMap = {
			column0: [],
			column1: [],
			column2: []
		};

		var LEGACY_FILTER_TO_CURRENT_FILTER_MAPPING = {
			'Business Unit': {'name': 'BusinessUnit', 'oldKey': 'businessunit'},
			'Factory': {'name': 'Factory', 'oldKey': 'factoryNdxs'},
			'Supplier': {'name': 'Supplier', 'oldKey': 'suppliers'},
			'Item Group': {'name': 'Item Group', 'oldKey': 'itemGroups'},
			'Time Period': {'name': 'TimePeriod', 'oldKey': 'timePeriod'},
			'Frequency': {'name': 'MetricFrequency', 'oldKey': 'frequency'},
			'Value Stream': {'name': 'ValueStream', 'oldKey': 'valueStreams'},
			'Category': {'name': 'AllMetricCategories', 'oldKey': 'categories'},
			'Metric': {'name': 'Metric', 'oldKey': 'metrics'},
			'Type': {'name': 'MetricTypes', 'oldKey': 'types'},
			'Task Status': {'name': 'TaskStatus'},
			'Task Category': {'name': 'TaskCategory'},
			'Lead Time': {'name': 'OutsideLeadTimeOnly', 'oldKey': 'leadTime'},
			'Lean Project Area': {'name': 'ProjectArea', 'oldKey': 'leanProjectAreas'},
			'Lean Project Stage': {'name': 'ProjectStageWithArchive', 'oldKey': 'leanProjectStages'},
			'Lean Project Manager': {'name': 'ProjectManager', 'oldKey': 'leanProjectManagers'},
			'Lean Project Type': {'name': 'ProjectTypes', 'oldKey': 'leanProjectTypes'},
			'Lean Project Category': {'name': 'ProjectCategories', 'oldKey': 'leanProjectCategories'},
			'Lean Project Goals': {'name': 'ProjectGoals', 'oldKey': 'undefined'}
		};

		var filtersMaster = ['BusinessUnit', 'Factory', 'Buyer', 'Planner', 'Item Group',
			'Supplier', 'TimePeriod', 'MetricFrequency', 'ValueStream', 'AllMetricCategories', 'MetricTypes',
			'Control Tower Time Period', 'Metric', 'Multi Factory', 'TaskStatus', 'TaskCategory', 'Order Policy',
			'ERP Order Policy', 'OutsideLeadTimeOnly', 'ProjectArea', 'ProjectStageWithArchive', 'ProjectManager',
			'ProjectTypes', 'ProjectCategories', 'ProjectGoals', 'Responsible',
			'LateDeliveryCategoryDescription', 'LateDeliveryCategoryLiability', 'MaterialGroup', 'MaterialType', 'ProjectStageNoStatic',
			'MyItemsOnly', 'ProjectSavingsCategories'
		];

		var filterGroups = {
			// dashboard-based filter groups
			performanceDashboard: {
				filters: ['Factory', 'BusinessUnit', 'MetricTypes', 'AllMetricCategories', 'ValueStream', 'Metric', 'TimePeriod', 'MetricFrequency'],
				widgets: [],
				eventName: 'performanceDashboardFilterChanged'
			},
			controlTower: {
				filters: ['Factory', 'BusinessUnit', 'ValueStream', 'AllMetricCategories', 'MetricTypes',
					'Control Tower Time Period', 'Metric', 'Multi Factory', 'MetricFrequency'
				],
				widgets: [],
				eventName: 'controlTowerFilterChanged'
			},
			buyerPerformance: {
				filters: ['Factory', 'Business Unit', 'Item Group'],
				widgets: [],
				eventName: 'buyerPerformanceFilterChanged'
			},
			posToAction12Month: {
				filters: ['Factory', 'BusinessUnit', 'Item Group', 'Supplier', 'Buyer', 'Planner', 'OutsideLeadTimeOnly',
					'TaskStatus', 'TaskCategory', 'Order Policy', 'ERP Order Policy', 'Responsible', 'MaterialGroup', 'MaterialType',
					'MyItemsOnly'
				],
				widgets: [],
				eventName: 'posToAction12MonthFilterChanged'
			},
			xMatrix: {
				filters: ['Factory', 'ProjectArea', 'ProjectStageNoStatic',
					'ProjectManager', 'ProjectTypes', 'ProjectCategories', 'ProjectGoals', 'CustomFields'],
				widgets: [],
				eventName: 'xMatrixFilterChanged'
			},
			// widget-based filter groups
			metric: {
				filters: ['TimePeriod', 'ValueStream', 'Factory', 'BusinessUnit'],
				widgets: ['metric'],
				eventName: 'metricFilterChanged'
			},
			leanProject: {
				filters: ['Factory', 'BusinessUnit', 'TimePeriod', 'ProjectArea', 'ProjectStageWithArchive',
					'ProjectManager', 'ProjectTypes', 'ProjectCategories', 'ProjectGoals', 'ProjectSavingsCategories', 'CustomFields'
				],
				widgets: ['initiativeCountByStages', 'projectSavingsByAreaAndStage',
					'leanProjectSummary', 'leanProjectTaskSummary', 'leanProjectMonthlySavings',
					'leanProjectProgressSummary', 'projectSavingsBySiteAndStage', 'projectSavingsByBusinessUnitAndStage',
					'generalProjectSavings'
				],
				eventName: 'leanProjectFilterChanged'
			},
			poPlacement: {
				filters: ['Factory', 'BusinessUnit', 'Buyer', 'Planner', 'Item Group',
					'Supplier', 'TaskStatus', 'TaskCategory', 'ERP Order Policy', 'MaterialGroup', 'MaterialType', 'Responsible', 'MyItemsOnly'
				],
				widgets: ['poPlacement', 'poConfirmation'],
				eventName: 'inventoryFilterChanged'
			},
			inventory: {
				filters: ['Factory', 'BusinessUnit', 'Buyer', 'Planner', 'Item Group',
					'Supplier', 'TaskStatus', 'TaskCategory', 'ERP Order Policy', 'MaterialGroup', 'MaterialType', 'Responsible', 'MyItemsOnly'
				],
				widgets: [], // everything that's not metric or leanProject
				eventName: 'inventoryFilterChanged'
			},
			posLateDeliveryCauses: {
				filters: ['Factory', 'Business Unit', 'Item Group', 'Supplier', 'Buyer', 'Planner', 'MaterialGroup',
					'MaterialType', 'TimePeriod', 'LateDeliveryCategoryDescription', 'LateDeliveryCategoryLiability', 'MyItemsOnly'
				],
				widgets: [],
				eventName: 'lateDeliveryCausesChartChanged'
			},
			workbench: {
				filters: ['Factory', 'Supplier', 'Buyer', 'TimePeriod'],
				widgets: ['workbenchTaskSummary', 'workbenchTaskTypeDistribution', 'workbenchAdjustmentDetails', 'workbenchHistoricalOverdue', 'workbenchTopUtfReasons'],
				eventName: 'workbenchFilterChanged'
			}
		};

		var metricWidgetCount = 0;
		var leanProjectWidgetCount = 0;
		var inventoryWidgetCount = 0;
		var poPlacementWidgetCount = 0;
		var workbenchWidgetCount = 0;

		return {
			updating: self.updating,
			initializeFilterList: initializeFilterList,
			addWidgetFilters: addWidgetFilters,
			removeWidgetFilters: removeWidgetFilters,
			loadFiltersConfig: loadFiltersConfig,
			updateFilters: updateFilters,
			getSelected: getSelected,
			getUnselected: getUnselected,
			markWidgetCreated: markWidgetCreated,
			setWidgetCreatingMap: setWidgetCreatingMap,
			getObjectList: getObjectList,
			setInitialLoad: setInitialLoad,
			isPerformanceDashboard: isPerformanceDashboard,
			setPerformanceDashboard: setPerformanceDashboard,
			finishInitialLoad: finishInitialLoad
		};

		function setPerformanceDashboard(val) {
			self.isPerformanceDashboard = val;
		}

		function isPerformanceDashboard() {
			return self.isPerformanceDashboard;
		}
		function setInitialLoad(val) {
			self.updating['initialLoad'] = val;
		}

		function setWidgetCreatingMap(widgetsMap) {
			widgetCreatingMap = widgetsMap;
		}

		function markWidgetCreated(column, position) {
			widgetCreatingMap[column][position] = false;
			if (!checkIfAnyCreating() && self.initialLoad) {
				self.initialLoad = false;
				$timeout(function() {
					leanFilterService.loadFilters();
				}, 0);
			}
		}

		function checkIfAnyCreating() {
			var column0Creating = widgetCreatingMap.column0.reduce(function(sum, next) {
				return sum || next;
			}, false);
			var column1Creating = widgetCreatingMap.column1.reduce(function(sum, next) {
				return sum || next;
			}, false);
			var column2Creating = widgetCreatingMap.column2.reduce(function(sum, next) {
				return sum || next;
			}, false);
			return column0Creating || column1Creating || column2Creating;
		}

		function initializeFilterList() {
			var state = storeService.getState().reportSettings;
			$timeout(function() {
				if (state.reportSettingsId && globalReportName === state.reportSettingsId) {
					leanFilterService.clearFilters();
					leanFilterService.setSearchBoxDataValue('');
					leanFilterService.useFactoryFilter = true;
					self.model = state;
					self.dashboardId = state.reportSettingsId;
					var widgetCount = 0;
					if (self.model) {
						self.initialLoad = true;
						self.updating['initialLoad'] = true;
						var widgets = getWidgets();
						metricWidgetCount = countMetricWidgets(widgets);
						leanProjectWidgetCount = countLeanProjectWidgets(widgets);
						inventoryWidgetCount = countInventoryWidgets(widgets);
						poPlacementWidgetCount = countPoPlacementWidgets(widgets);
						workbenchWidgetCount = countWorkbenchWidgets(widgets);
						widgetCount = metricWidgetCount + leanProjectWidgetCount + inventoryWidgetCount + poPlacementWidgetCount + workbenchWidgetCount + workbenchWidgetCount;
						// these dashboards have a fixed set of filters
						self.isControlTowerDashboard = self.model.baseReportName === 'Control tower';
						self.isPerformanceDashboard = self.model.baseReportName === performanceDashboardDescription;
						self.isPosToAction12MonthDashboard = self.model.baseReportName === 'POs to action: next 12 months';
						self.isXMatrixDashboard = self.model.baseReportName === 'X-matrix';
						self.isPosLateDeliveryCausesDashboard = self.model.baseReportName === 'Late delivery causes';
					}
					loadFiltersConfig({id: self.dashboardId}, widgetCount);
				}
			}, 0);
		}

		function loadFiltersConfig(args, widgetCount) {
			if (self.dashboardId === args.id) {
				// go through and build the multieselect list of filters
				var filtersDefinitions = buildFilters(widgetCount);
				if (self.isXMatrixDashboard) {
					leanFilterService.useFactoryFilter = true;
				}
				if (self.isPerformanceDashboard) {
					leanFilterService.filterDefinitions.TimePeriod.removable = false;
				} else if (self.isPosLateDeliveryCausesDashboard) {
					leanFilterService.filterDefinitions.LateDeliveryCategoryDescription.staticOption = null;
				}
				leanFilterService.clearFiltersLoaded();
				leanTableConfigService.setMandatoryDefaultFilters(!self.isXMatrixDashboard);
				setDashboardDefaultFilters();
				leanFilterService.setMasterFilterList(filtersDefinitions['multieselectFilters']);
				leanFilterService.setMasterSingleSelectFilterList(filtersDefinitions['singleselectFilters']);
				leanFilterService.setMasterRangeFilterList(filtersDefinitions['rangeFilters']);
				var config = loadFiltersFromConfig(self.model.filterConfig);
				config.dashboardId = self.dashboardId.toString();
				config.reportSettingsName = self.model.name;
				leanTableConfigService.setFiltersConfigFromDashboard(config);
				populateCustomFieldsFilters();
			}
		}

		function populateCustomFieldsFilters() {
			for (var groupName in filterGroups) {
				if (filterGroups.hasOwnProperty(groupName)) {
					var group = filterGroups[groupName];
					var groupHasFilter = group.filters.includes('CustomFields');
					if (groupHasFilter) {
						var reportIsPresent = getReports().some(function (report) {
							return report === groupName;
						});
						if (reportIsPresent) {
							leanFilterService.addCustomFieldsFilters();
							return;
						}
						var widgetIsPresent = group.widgets.some(function (widget) {
							return getWidgets().some(function (presentWidget) {
								return presentWidget.type === widget;
							});
						});
						if (widgetIsPresent) {
							leanFilterService.addCustomFieldsFilters();
							return;
						}
					}
				}
			}
		}

		function finishInitialLoad() {
			self.updating['initialLoad'] = false;
			$rootScope.$broadcast('performanceDashboardFilterChanged');
			$rootScope.$broadcast('buyerPerformanceFilterChanged');
			if (self.isPerformanceDashboard && (!widgetList || (widgetList && widgetList.length == 0))) {
				self.initialLoad = false;
				$timeout(function() {
					leanFilterService.loadFilters();
				}, 0);
			}
		}

		function setDashboardDefaultFilters() {
			var defaultFilters = [{'id': 'factory', 'values': [globalConfig.factory.id], 'isMandatory': true}];
			if (self.isControlTowerDashboard) {
				defaultFilters.push({'id': 'controlTowerTimePeriod', 'values': ['Current'], 'isMandatory': true});
				leanTableConfigService.setMandatoryDefaultFilters(true);
			} else if (self.isPerformanceDashboard) {
				defaultFilters.push({'id': 'timePeriod', 'value': 'current', 'isMandatory': true});
				leanTableConfigService.setMandatoryDefaultFilters(true);
			}
			leanTableConfigService.setDefaultFilters(defaultFilters);
			leanFilterService.defaultFilters = defaultFilters;
		}

		function getCurrentWidgets() {
			var state = storeService.getState().reportSettings;
			if (!state || !state.config || state.reportSettingsId !== self.dashboardId) {
				return self.model && self.model.config ? getWidgets() : [];
			}
			var column0 = state.config.column0 || [];
			var column1 = state.config.column1 || [];
			var column2 = state.config.column2 || [];
			return column0.concat(column1).concat(column2).map(function (wid) {
				return { type: wid.config.type };
			});
		}

		function getTaskCategoryFilterDefinition() {
			var filterDefinition = leanFilterService.filterDefinitions['TaskCategory'];
			var widgets = getCurrentWidgets();
			var shouldExclude = !widgets.some(function (w) { return w.type === 'myInventoryActions'; });
			if (shouldExclude) {
				filterDefinition = angular.copy(filterDefinition);
				filterDefinition.excludeOptionNames = ['Inventory Action', 'Inventory Action (legacy)'];
				if (filterDefinition.objectList) {
					filterDefinition.objectList.length = 0;
				} else {
					filterDefinition.objectList = [];
				}
			}
			return filterDefinition;
		}

		function buildFilters(widgetCount) {
			var filters = {
				multieselectFilters: [],
				singleselectFilters: [],
				rangeFilters: []
			};
			for (var i = 0; i < filtersMaster.length; i++) {
				var filterName = filtersMaster[i];
				if (filterIsValid(filterName, widgetCount)) {
					var filterDefinition = filterName === 'TaskCategory'
						? getTaskCategoryFilterDefinition()
						: leanFilterService.filterDefinitions[filterName];
					if (!filterDefinition.excludeFromFilterList) {
						if (filterName === 'Factory') {
							filterDefinition.removable = false;
							if (self.isXMatrixDashboard) {
								filterDefinition.type = 'singleSelect';
							}
						}
						if (filterDefinition.type === 'singleSelect') {
							filters['singleselectFilters'].push(filterDefinition);
						} else if (filterDefinition.type === 'date' || filterDefinition.type === 'numerical') {
							filters['rangeFilters'].push(filterDefinition);
						} else {
							filters['multieselectFilters'].push(filterDefinition);
						}
					}
				}
			}
			return filters;
		}

		function filterIsValid(filterName, widgetCount) {
			// add to new state after checking the filter is valid
			var isValid = false;
			// check against dashboards that have a fixed set of filters
			if (self.isControlTowerDashboard) {
				if (filterGroups['controlTower'].filters.indexOf(filterName) !== -1) {
					isValid = true;
				}
			} else if (self.isPerformanceDashboard) {
				if (filterGroups['performanceDashboard'].filters.indexOf(filterName) !== -1) {
					isValid = true;
				}
			} else if (self.isPosToAction12MonthDashboard) {
				if (filterGroups['posToAction12Month'].filters.indexOf(filterName) !== -1) {
					isValid = true;
				}
			} else if (self.isXMatrixDashboard) {
				if (filterGroups['xMatrix'].filters.indexOf(filterName) !== -1) {
					isValid = true;
				}
				// filters that exist when certain widgets are present
			} else if (self.isPosLateDeliveryCausesDashboard) {
				if (filterGroups['posLateDeliveryCauses'].filters.indexOf(filterName) !== -1) {
					isValid = true;
				}
			} else if (metricWidgetCount > 0 &&
				filterGroups['metric'].filters.indexOf(filterName) !== -1) {
				isValid = true;
			} else if (leanProjectWidgetCount > 0 &&
				filterGroups['leanProject'].filters.indexOf(filterName) !== -1) {
				isValid = true;
			} else if (poPlacementWidgetCount > 0 &&
				filterGroups['poPlacement'].filters.indexOf(filterName) !== -1) {
				isValid = true;
			} else if (inventoryWidgetCount > 0 &&
				filterGroups['inventory'].filters.indexOf(filterName) !== -1) {
				isValid = true;
			} else if (workbenchWidgetCount > 0 &&
				filterGroups['workbench'].filters.indexOf(filterName) !== -1) {
				isValid = true;
			} else {
				// Load factory filter for empty dashboard
				if (filterName === 'Factory' && !widgetCount) {
					isValid = true;
				}
			}
			return isValid;
		}

		function getWidgets() {
			var column0 = self.model.config.column0 || [];
			var column1 = self.model.config.column1 || [];
			var column2 = self.model.config.column2 || [];
			return column0.concat(column1).concat(column2).map(function(wid) {
				return { type: wid.config.type };
			});
		}

		function getReports() {
			var column0 = self.model.config.column0 || [];
			var column1 = self.model.config.column1 || [];
			var column2 = self.model.config.column2 || [];
			return column0.concat(column1).concat(column2)
				.filter(function(col) {
					return col.name;
				})
				.map(function(col) {
					return col.name;
				});
		}

		function countMetricWidgets(widgets) {
			var count = 0;
			if (widgets) {
				for (var i = 0; i < widgets.length; i++) {
					if (filterGroups['metric'].widgets.indexOf(widgets[i].type) !== -1) {
						count += 1;
					}
				}
			}
			return count;
		}

		function countLeanProjectWidgets(widgets) {
			var count = 0;
			if (widgets) {
				for (var i = 0; i < widgets.length; i++) {
					if (filterGroups['leanProject'].widgets.indexOf(widgets[i].type) !== -1) {
						count += 1;
					}
				}
			}
			return count;
		}

		function countWorkbenchWidgets(widgets) {
			var count = 0;
			if (widgets) {
				for (var i = 0; i < widgets.length; i++) {
					if (filterGroups['workbench'].widgets.indexOf(widgets[i].type) !== -1) {
						count += 1;
					}
				}
			}
			return count;
		}

		function countInventoryWidgets(widgets) {
			var count = 0;
			if (widgets) {
				for (var i = 0; i < widgets.length; i++) {
					// anything that's not a metric or lean project or workbench widget, for now
					if (filterGroups['metric'].widgets.indexOf(widgets[i].type) === -1 &&
						filterGroups['leanProject'].widgets.indexOf(widgets[i].type) === -1 &&
						filterGroups['workbench'].widgets.indexOf(widgets[i].type) === -1) {
						count += 1;
					}
				}
			}
			return count;
		}

		function countPoPlacementWidgets(widgets) {
			var count = 0;
			if (widgets) {
				for (var i = 0; i < widgets.length; i++) {
					// anything that's not a metric or lean project widget, for now
					if (filterGroups['poPlacement'].widgets.indexOf(widgets[i].type) !== -1) {
						count += 1;
					}
				}
			}
			return count;
		}

		function loadFiltersFromConfig(filterConfig) {
			var config;
			// Check that filter config isn't empty
			if (filterConfig) {
				if (filterConfig.activeFilters) {
					config = {
						'filters': []
					};
					for (var i = 0; i < filterConfig.activeFilters.length; i++) {
						var defaultConfig = getDefaultFilterConfig();
						var legacyFilter = LEGACY_FILTER_TO_CURRENT_FILTER_MAPPING[filterConfig.activeFilters[i]];
						var currentFilter;
						var values;
						if (legacyFilter) {
							currentFilter = leanFilterService.filterDefinitions[legacyFilter.name];
							values = filterConfig[(legacyFilter.oldKey ? legacyFilter.oldKey: currentFilter.id)];
						} else {
							currentFilter = leanFilterService.filterDefinitions[filterConfig.activeFilters[i]];
							values = filterConfig[currentFilter.id];
						}
						defaultConfig.id = currentFilter.id;
						if (currentFilter.type === 'date') {
							defaultConfig.value = currentFilter.getValidTimePeriodValue(values[0], currentFilter.objectList);
						} else {
							defaultConfig.values = values;
						}

						config.filters.push(defaultConfig);
					}
					if (config.filters.length) {
						config.userModified = true;
					}
				} else if (filterConfig.filters) {
					config = filterConfig;
					if (config.filters.length) {
						config.userModified = true;
					}
				} else {
					config = getDefaultConfig();
				}
			} else {
				config = getDefaultConfig();
			}
			return config;
		}

		function getDefaultConfig() {
			return {
				filters: leanFilterService.getDefaultFilters(),
				recordsPerPage: 50,
				search: '',
				columns: [],
				defaultConfig: true
			};
		}

		function getDefaultFilterConfig() {
			return {
				'id': '',
				'values': [],
				'unselectedValues': null,
				'comparator': null,
				'valueOne': null,
				'valueTwo': null,
				'value': null
			};
		}

		function getFilterNameById(filterId) {
			var filterName = null;
			for (var i = 0; i < filtersMaster.length; i++) {
				if (leanFilterService.filterDefinitions[filtersMaster[i]].id === filterId) {
					filterName = filtersMaster[i];
					break;
				}
			}
			return filterName;
		}

		function updateFilters(waitForFilters, filterId) {
			if (!waitForFilters || !leanFilterService.isLoading()) {
				broadcastFilterChangedEvents(filterId);
			} else {
				setTimeout(function () {
					updateFilters(waitForFilters, filterId);
				}, 10);
			}
		}

		function broadcastFilterChangedEvents(filterId) {
			var filterName;
			if (filterId.startsWith('cus_')) {
				filterName = 'CustomFields';
				$rootScope.$broadcast(leanFilterService.filterDefinitions[filterId].dashboardEventName);
			} else {
				filterName = getFilterNameById(filterId);
				$rootScope.$broadcast(leanFilterService.filterDefinitions[filterName].dashboardEventName);
			}
			var broadcastedEventNames = [];
			if (filterName) {
				for (var groupName in filterGroups) {
					if (filterGroups.hasOwnProperty(groupName)) {
						var group = filterGroups[groupName];
						// Prevent sending multiple boradcast event of same group using broadcastedEventNames list
						if (group.filters.indexOf(filterName) !== -1 &&
							broadcastedEventNames.indexOf(group.eventName) === -1) {
							broadcastedEventNames.push(group.eventName);
							$rootScope.$broadcast(group.eventName);
						}
					}
				}
			}
		}

		function getFilterIdByName(filterName) {
			var legacyFilter = LEGACY_FILTER_TO_CURRENT_FILTER_MAPPING[filterName];
			var filter;
			if (legacyFilter) {
				filter = leanFilterService.filterDefinitions[legacyFilter.name];
			} else {
				filter = leanFilterService.filterDefinitions[filterName];
			}
			return filter.id;
		}

		function getSelected(filterName) {
			if (filterName === 'Factory') {
				return leanFilterService.getFactoryList();
			}
			var filter = leanFilterService.getFilterById(getFilterIdByName(filterName));
			var queryParams = leanFilterService.getQueryParamsObject(true);
			var queryParamsFilter = queryParams.filter;
			if (queryParamsFilter) {
				var filterParams = getFilterQueryParamValues(queryParamsFilter);
				if (filterParams && filterParams.length) {
					var foundFilterParam = filterParams.find(function (filterParam) {
						return filterParam.field === filter.id;
					});
					if (foundFilterParam) {
						queryParams[filter.id] = foundFilterParam.value;
					}
				}
			}
			return filter ? queryParams[filter.id]: undefined;
		}

		function getFilterQueryParamValues(filtersArrayString) {
			filtersArrayString = filtersArrayString.replaceAll('\'', '\"');
			return JSON.parse(filtersArrayString);
		}

		function getUnselected(filterName) {
			var queryParams =  leanFilterService.getQueryParamsObject(true);
			var filter = leanFilterService.getFilterById(getFilterIdByName(filterName));
			var filterId = filter.id;
			var key = 'not' + filterId.charAt(0).toUpperCase() + filterId.slice(1);
			return queryParams[key];
		}

		function getObjectList(filterName) {
			var filter = leanFilterService.getFilterById(getFilterIdByName(filterName));
			return filter && filter['objectList'] ? filter.objectList : [];
		}

		function addWidgetFilters(widget) {
			var rebuildNeeded = checkRebuildNeeded(widget, 1, 1);

			if (rebuildNeeded) {
				rebuildFilters(true, widget);
				$timeout(function(){
					leanFilterService.reloadFactoryFilters(true, true);
				}, 0);
			}
		}

		function removeWidgetFilters(widget) {
			var rebuildNeeded = checkRebuildNeeded(widget, -1, 0);

			if (rebuildNeeded) {
				rebuildFilters();
				$timeout(function(){
					leanFilterService.reloadFactoryFilters(true, true);
				}, 0);
			}
		}

		function checkRebuildNeeded(widget, increment, comparison) {
			var rebuildNeeded = false;
			// update counts of widget types
			if (filterGroups['metric'].widgets.indexOf(widget) !== -1) {
				metricWidgetCount += increment;
				if (metricWidgetCount === comparison) {
					rebuildNeeded = true;
				}
			}
			if (filterGroups['leanProject'].widgets.indexOf(widget) !== -1) {
				leanProjectWidgetCount += increment;
				if (leanProjectWidgetCount === comparison) {
					rebuildNeeded = true;
				}
			}
			if (filterGroups['poPlacement'].widgets.indexOf(widget) !== -1) {
				poPlacementWidgetCount += increment;
				if (poPlacementWidgetCount === comparison) {
					rebuildNeeded = true;
				}
			}
			if (filterGroups['metric'].widgets.indexOf(widget) === -1 &&
				filterGroups['leanProject'].widgets.indexOf(widget) === -1 && 
				filterGroups['workbench'].widgets.indexOf(widget) === -1) {
				inventoryWidgetCount += increment;
				if (inventoryWidgetCount === comparison) {
					rebuildNeeded = true;
				}
			}
			if (filterGroups['workbench'].widgets.indexOf(widget) !== -1) {
				workbenchWidgetCount += increment;
				if (workbenchWidgetCount === comparison) {
					rebuildNeeded = true;
				}
			}
			return rebuildNeeded;
		}

		function filtersChanged(start, loadFilters, waitForFilters, isFilterChanged, filterId) {
			updateFilters(waitForFilters, filterId);
		}

		// refresh the state of all filters
		function rebuildFilters(addCustomFields, widgetName) {
			var activeFilters = leanFilterService.activeFilters;
			activeFilters = activeFilters.map(function(filter) {
				return getFilterNameById(filter.id);
			});
			var masterSingleSelectFilterList = [];
			var masterRangeFilterList = [];
			var masterFilterList = [];
			var masterStringFilterList = [];
			var filtersToUpdate = filtersMaster.slice();
			for (var groupName in filterGroups) {
				if (filterGroups.hasOwnProperty(groupName)) {
					var group = filterGroups[groupName];
					var groupWithWidget = group.widgets.includes(widgetName);
					var groupHasFilter = group.filters.includes('CustomFields');
					if (groupWithWidget && groupHasFilter) {
						var customFieldDefinitions = Object.keys(leanFilterService.filterDefinitions).filter(function (filterKey) {
							return filterKey.startsWith('cus_');
						});
						filtersToUpdate = filtersToUpdate.concat(customFieldDefinitions);
					}
				}
			}
			for (var i = 0; i < filtersToUpdate.length; i++) {
				var filterName = filtersToUpdate[i];
				if (!leanFilterService.filterDefinitions[filterName].excludeFromFilterList) {
					// try to re-add each filter to the list it's currently in.
					// always set filter as active if it doesn't allow removal
					if ((activeFilters && activeFilters.indexOf(filterName) !== -1)) {
						if (!filterIsValid(filterName)) {
							tableFilterFunctionsService.removeFilterInner(leanFilterService.filterDefinitions[filterName],
								filtersChanged);
						} else {
							var defToAdd = filterName === 'TaskCategory' ? getTaskCategoryFilterDefinition() : leanFilterService.filterDefinitions[filterName];
							addFilterToList(defToAdd, masterSingleSelectFilterList,
								masterRangeFilterList, masterFilterList, masterStringFilterList);
						}
					} else {
						// add missing filters
						if (filterIsValid(filterName) || filterName.startsWith('cus_')) {
							var filterDefinition = filterName === 'TaskCategory' ? getTaskCategoryFilterDefinition() : leanFilterService.filterDefinitions[filterName];
							if (filterName === 'Factory') {
								filterDefinition.removable = false;
							}
							addFilterToList(filterDefinition, masterSingleSelectFilterList,
								masterRangeFilterList, masterFilterList, masterStringFilterList);
						}
					}
				}

			}
			leanFilterService.setMasterFilterList(masterFilterList);
			leanFilterService.setMasterSingleSelectFilterList(masterSingleSelectFilterList);
			leanFilterService.setMasterRangeFilterList(masterRangeFilterList);
			leanFilterService.setMasterStringFilterList(masterStringFilterList);
		}

		function addFilterToList(filterDefinition, masterSingleSelectFilterList, masterRangeFilterList, masterFilterList,
								 masterStringFilterList) {
			if (filterDefinition.type === 'singleSelect') {
				masterSingleSelectFilterList.push(filterDefinition);
			} else if (filterDefinition.type === 'date' || filterDefinition.type === 'numerical') {
				masterRangeFilterList.push(filterDefinition);
			} else if (filterDefinition.type === 'string') {
				masterStringFilterList.push(filterDefinition);
			} else {
				masterFilterList.push(filterDefinition);
			}
		}
	}
})();
